import * as React from "react";
import { Component } from "react";
import { Redirect } from "react-router";
import LoadingStatus from "src/components/common/LoadingStatus";
import { IDefaultProps } from "src/interfaces";
import ProjectSettings from "../../components/projects/ProjectSettings";
import fs from "../../services/config/fbConfig";
import { IProjectSettingsPageState } from "./interfaces";

export default class ProjectSettingsPage extends Component<
  IDefaultProps,
  IProjectSettingsPageState
> {
  private projectDocument: firebase.firestore.DocumentReference;
  public constructor(props: IDefaultProps) {
    super(props);

    this.state = {
      loading: true,
      useSimplifiedStatement: false,
      rateType: 0,
      isDirty: false,
      checkEstimatedGeneration: false,
      allowStatementUpload: false,
      allowStatementParsing: false,
      priorDataEditable: false,
      location: "",
    };

    this.saveSettings = this.saveSettings.bind(this);
    this.handleUseSimplifiedStatement = this.handleUseSimplifiedStatement.bind(this);
    this.handleRateTypeChanged = this.handleRateTypeChanged.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCheckEstimatedGenerationChanged = this.handleCheckEstimatedGenerationChanged.bind(
      this
    );
    this.handleAllowStatementUploadChanged = this.handleAllowStatementUploadChanged.bind(this);
    this.handleAllowStatementParsingChanged = this.handleAllowStatementParsingChanged.bind(this);
    this.handlePriorDataEditableChanged = this.handlePriorDataEditableChanged.bind(this);
    this.locationChanged = this.locationChanged.bind(this);
  }

  public componentWillMount() {
    this.projectDocument = fs.fs.collection("projects").doc(this.props.match.params.id);
  }

  public componentDidMount() {
    this.projectDocument
      .get()
      .then(doc => {
        if (doc.exists) {
          const {
            useSimplifiedStatement,
            rateType,
            checkEstimatedGeneration,
            allowStatementUpload,
            allowStatementParsing,
            priorDataEditable,
            location,
          } = doc.data() as any;
          this.setState({
            useSimplifiedStatement:
              useSimplifiedStatement !== undefined ? useSimplifiedStatement : false,
            checkEstimatedGeneration:
              checkEstimatedGeneration !== undefined ? checkEstimatedGeneration : true,
            rateType: rateType ? Number(rateType) : 0,
            allowStatementUpload: allowStatementUpload !== undefined ? allowStatementUpload : false,
            allowStatementParsing:
              allowStatementParsing !== undefined ? allowStatementParsing : false,
            priorDataEditable: priorDataEditable !== undefined ? priorDataEditable : false,
            location: location ? location : "",
          });
        }
      })
      .then(() => {
        this.setState({ loading: false, isDirty: false });
      });
  }

  public render() {
    const { appService } = this.props;

    if (!appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (this.state.loading) {
      return <LoadingStatus text="Loading..." type="Circles" />;
    }

    return (
      <div className="flex-column container-fixed-navbar">
        <ProjectSettings
          appService={this.props.appService}
          history={this.props.history}
          match={this.props.match}
          saveSettings={this.saveSettings}
          useSimplifiedStatement={this.state.useSimplifiedStatement}
          rateType={this.state.rateType}
          handleUseSimplifiedStatementChanged={this.handleUseSimplifiedStatement}
          handleRateTypeChanged={this.handleRateTypeChanged}
          handleCancel={this.handleCancel}
          checkEstimatedGeneration={this.state.checkEstimatedGeneration}
          handleCheckEstimatedGenerationChanged={this.handleCheckEstimatedGenerationChanged}
          allowStatementUpload={this.state.allowStatementUpload}
          allowStatementParsing={this.state.allowStatementParsing}
          handleAllowStatementUploadChanged={this.handleAllowStatementUploadChanged}
          handleAllowStatementParsingChanged={this.handleAllowStatementParsingChanged}
          priorDataEditable={this.state.priorDataEditable}
          handlePriorDataEditableChanged={this.handlePriorDataEditableChanged}
          location={this.state.location}
          locationChanged={this.locationChanged}
        />
      </div>
    );
  }

  private handleUseSimplifiedStatement(value: boolean): void {
    this.setState({ useSimplifiedStatement: value, isDirty: true });
  }
  private handleRateTypeChanged(value: number): void {
    this.setState({ rateType: value, isDirty: true });
  }
  private handleCheckEstimatedGenerationChanged(value: boolean): void {
    this.setState({ checkEstimatedGeneration: value, isDirty: true });
  }

  private handleAllowStatementUploadChanged(value: boolean): void {
    this.setState({ allowStatementUpload: value, isDirty: true });
  }
  private handleAllowStatementParsingChanged(value: boolean): void {
    this.setState({ allowStatementParsing: value, isDirty: true });
  }

  private handlePriorDataEditableChanged(value: boolean): void {
    this.setState({ priorDataEditable: value, isDirty: true });
  }

  private locationChanged(value: string): void {
    this.setState({ location: value });
  }

  private saveSettings(
    location: string,
    useSimplifiedStatement: boolean,
    rateType: number,
    checkEstimatedGeneration: boolean,
    allowStatementUpload: boolean,
    allowStatementParsing: boolean,
    priorDataEditable: boolean
  ): void {
    this.setState({ loading: true });
    this.projectDocument
      .update({
        useSimplifiedStatement,
        rateType,
        checkEstimatedGeneration,
        allowStatementUpload,
        allowStatementParsing,
        priorDataEditable,
        location,
      })
      .then(() => {
        this.setState({
          useSimplifiedStatement,
          rateType,
          checkEstimatedGeneration,
          allowStatementUpload,
          allowStatementParsing,
          priorDataEditable,
          loading: false,
        });
      })
      .then(() => {
        this.setState({ loading: false });
      })
      .then(() => {
        const { appService } = this.props;
        appService.setActiveProject(this.props.match.params.id, location);
        this.props.history.push(`/project/${this.props.match.params.id}`);
      });
  }
  private handleCancel() {
    this.props.history.push(`/project/${this.props.match.params.id}`);
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/ProjectSettingsPage.tsx